// @ts-nocheck
import isEqual from "lodash/isEqual";

let cachedObject: any;

export default (object: any, key: any) => {
    if (typeof key !== "string") {
        return false;
    }

    let isCss = key.toLowerCase().endsWith("css");

    const cachedProp = cachedObject?.[key];
    if (cachedProp && isEqual(cachedProp, object)) {
        isCss = true;
    }

    if (key === "cssOverrides") {
        cachedObject = object;
    }

    return isCss;
};
